type NavigationGuard = (proceed: () => void) => boolean;
let active: { guard: NavigationGuard } | null = null;

/** Protects this mounted draft only; it never decides destination authority. */
export function registerHqHalfyearNavigationGuard(guard: NavigationGuard) {
  const owner = { guard };
  active = owner;
  return () => { if (active === owner) active = null; };
}

/** Returns true when the current draft deferred or blocked the requested move. */
export function deferHqHalfyearNavigation(proceed: () => void): boolean {
  return active?.guard(proceed) ?? false;
}
